import { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Input, Form, Checkbox } from "semantic-ui-react";
import {
  updateBeneficiatioState,
  resetBeneficiarioState,
  getBeneficiario,
} from "@store/actions/index";
import AjaxLoader from "../shared/ajax_loader";
import CustomSnackbar from "../shared/custom_snackbar";
import ErrorMsgLabel from "../shared/errorMsgLabel";
import {
  dateDividers,
  reverseMaskDate,
  getTodayDate,
  lastDayOfTheMonth,
} from "@utils/date";
import _ from "lodash";
import "@styles/consulta-eletiva.css";
import m from "@utils/strings";

class FormElegibilidade extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: reverseMaskDate(getTodayDate()),
      numeroCarteira: "",
      success: false,
      error: false,
      showLoader: false,
      disabled: false,
      beneficiarioDTO: {},
      hasSubmitted: false,
      isDateValid: true,
      isNumeroCarteiraEmpty: false,
      recemNascido: false,
      hasReceivedResult: false,
    };

    this.focus = this.focus.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSetInitialFieldsState =
      this.handleSetInitialFieldsState.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
    this.props.setInitialFieldsState(this.handleSetInitialFieldsState);
    this.props.focusFirstFieldAutorizacao(this.focus);
    this.props.validateAutorizacaoFields(this.handleSubmit);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleKeyDown(event) {
    if (event.key === "Enter" && this.state.hasReceivedResult) {
      event.preventDefault();
      this.props.novoAtendimento();
      return;
    } else if (event.key === "Enter" && !this.state.hasReceivedResult) {
      event.preventDefault();
      this.handleSubmit();
      return;
    }
  }

  focus() {
    setTimeout(() => {
      if (this.textInput) this.textInput.focus();
    }, 1000);
  }

  handleCheckboxChange = () => {
    this.setState({ recemNascido: !this.state.recemNascido });
  };

  handleChange = (event) => {
    let target = event.target;
    let value = target.value.toString();
    let name = target.name;

    if (_.isEmpty(value)) {
      this.setState({ isNumeroCarteiraEmpty: true });
    } else {
      this.setState({ isNumeroCarteiraEmpty: false });
    }

    value = value.replace(
      /([.*+?^=!:;">,<'´`~&%$#@${}()|\[\]\\a-zA-Z\/\-\_])/g,
      ""
    );
    this.setState({
      [name]: value,
    });
  };

  dateChange = (event, { name, value }) => {
    let temp = reverseMaskDate(value, dateDividers.DASH, dateDividers.BAR);
    let splitDate = temp.split("/");

    if (splitDate.length === 3) {
      if (parseInt(splitDate[1], 10) > 12) splitDate[1] = "1";

      if (
        splitDate[1].length > 0 &&
        parseInt(splitDate[0], 10) >
          lastDayOfTheMonth(parseInt(splitDate[1], 10))
      )
        splitDate[0] = "1";
      if (splitDate[2].length <= 4) {
        // value = splitDate[0] + "/" + splitDate[1] + "/" + splitDate[2];
        this.setState({ [name]: value });
      }
      if (
        splitDate[2].length === 4 &&
        new Date(`${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`) > new Date()
      ) {
        this.dataMaior();
        this.setState({ [name]: reverseMaskDate(getTodayDate()) });
      }
    } else if (splitDate.length > 3) {
    } else {
      this.setState({ [name]: value });
    }

    if (
      splitDate.length === 3 &&
      splitDate[0].length > 0 &&
      splitDate[1].length > 0 &&
      splitDate[2].length > 0 &&
      !this.isDateValid(splitDate)
    ) {
      this.setState({ isDateValid: false });
    } else {
      this.setState({ isDateValid: true });
    }
  };

  buildBeneficiarioParams = (date) => {
    const { willAuthorize, prestador, tipoAtendimento } = this.props;

    const beneficiarioDTO = {
      CNPJPrestador: prestador.CPF_CNPJ,
      NomePrestador: prestador.Nome,
      NumeroCarteiraBeneficiario: this.state.numeroCarteira,
      NomeBeneficiario: "USUARIO GENERICO",
      CartaoNacionalSaude: "",
      DataAtual: date,
      HoraAtual: "",
      RegistroANS: "",
      RecemNascido: this.state.recemNascido,
      willAuthorize: willAuthorize,
      TipoAtendimento: tipoAtendimento,
    };

    this.setState({ beneficiarioDTO: beneficiarioDTO });
    return beneficiarioDTO;
  };

  isDateValid = (date) => {
    if (
      date.length != 3 ||
      date[1].length === 0 ||
      date[0].length === 0 ||
      date[2].length === 0
    )
      return false;
    if (
      new Date(`${date[1]}/${date[0]}/${date[2]}`).toString() === "Invalid Date"
    )
      return false;
    return true;
  };

  handleSubmit(event) {
    if (!this.state.hasSubmitted) {
      let date = reverseMaskDate(
        this.state.date,
        dateDividers.DASH,
        dateDividers.BAR
      ).split("/");
      if (!this.isDateValid(date) || date[2].length < 4) {
        this.setState({ isDateValid: false });
        return;
      } else {
        this.setState({ isDateValid: true });
      }

      if (_.isEmpty(this.state.numeroCarteira)) {
        this.setState({ isNumeroCarteiraEmpty: true });
        return;
      } else {
        this.setState({ isNumeroCarteiraEmpty: false });
      }

      let areAllSolicitacaoFieldsFilled = false;
      if (
        _.isFunction(this.props.verificarSeCamposSolicitacaoEstaoPreenchidos)
      ) {
        areAllSolicitacaoFieldsFilled =
          this.props.verificarSeCamposSolicitacaoEstaoPreenchidos();
      }

      if (
        this.state.isDateValid &&
        !_.isEmpty(this.state.numeroCarteira) &&
        areAllSolicitacaoFieldsFilled
      ) {
        this.setState({
          hasSubmitted: true,
          showLoader: !this.state.showLoader,
        });
        const params = this.buildBeneficiarioParams(
          new Date(`${date[1]}/${date[0]}/${date[2]}`)
        );
        this.props.getBeneficiario(
          params,
          (result) => {
            this.setState({
              showLoader: !this.state.showLoader,
              hasSubmitted: false,
              hasReceivedResult: true,
            });
            this.handleSubmitResult(result);
          },
          (error) => {
            this.handleSubmitError();
          }
        );
      }
    }
  }

  handleSubmitResult = (result) => {
    this.props.updateBeneficiatioState(result);
    const {
      data: { Elegibilidade },
    } = result;
    if (Elegibilidade == null) {
      this.setState({
        error: true,
        success: false,
        disabled: true,
      });
      this.props.onEligibilityResponse?.({
        motive: "error",
        message: m.TELA_CONSULTA_ELETIVA.MENSAGEM_ERRO_SERVICO_ELEGIBILIDADE,
      });
      return;
    }
    if (Elegibilidade.IndicadorElegibilidade != "S" && Elegibilidade.CodigoMotivoNegativa) {
      this.setState({
        error: true,
        success: false,
        disabled: true,
      });
      this.props.onEligibilityResponse?.(
        {
          motive: "denied",
          message: `${Elegibilidade.CodigoMotivoNegativa} - ${Elegibilidade.DescricaoMotivoNegativa}`,
        },
        result
      );
      return;
    }
    this.setState({
      success: true,
      error: false,
      disabled: true,
    });
    let resultParam = result.data.Elegibilidade;
    resultParam.RN = this.state.beneficiarioDTO.RecemNascido;
    this.props.updateDadosBeneficiario({
      beneficiarioDTO: resultParam,
    });
    this.props.onEligibilityResponse?.(null, result);
    return;
  };

  handleSubmitError = () => {
    this.props.onEligibilityResponse?.({
      motive: "error",
      message: m.TELA_CONSULTA_ELETIVA.MENSAGEM_ERRO_SERVICO_ELEGIBILIDADE,
    });
    this.props.updateBeneficiatioState("API_ERROR");
    this.setState({
      hasSubmitted: false,
      hasReceivedResult: false,
      showLoader: !this.state.showLoader,
    });
    this.clickChild();
    this.setState({
      error: true,
      success: false,
      disabled: true,
    });
  };

  handleSetInitialFieldsState = () => {
    this.props.resetBeneficiarioState();
    this.setState({
      date: reverseMaskDate(getTodayDate()),
      numeroCarteira: "",
      success: false,
      error: false,
      showLoader: false,
      disabled: false,
      beneficiarioDTO: {},
      hasSubmitted: false,
      isNumeroCarteiraEmpty: false,
      recemNascido: false,
      hasReceivedResult: false,
    });
    this.focus();
  };

  render() {
    const { beneficiario } = this.props;

    const fieldClassName = `${
      this.state.success && beneficiario ? "success" : ""
    } 
            ${this.state.error && beneficiario ? "error" : ""}
            ${this.state.disabled && beneficiario ? "disabled" : ""}`;

    const numeroCarteiraClassName = `${
      this.state.success && beneficiario ? "success" : ""
    } 
            ${this.state.isNumeroCarteiraEmpty ? "error" : ""}
            ${this.state.disabled && beneficiario ? "disabled" : ""}`;

    const loader = this.state.showLoader ? <AjaxLoader /> : "";

    if (this.state.numeroCarteira.length > 17)
      this.setState({ numeroCarteira: this.state.numeroCarteira.slice(0, 17) });

    return (
      <div className={"form-elegibilidade"}>
        {loader}
        <Form>
          <Form.Group>
            <Form.Field inline={true} className={fieldClassName} width={10}>
              <div>
                <label className={"form-autorizacao-label"}>
                  {m.TELA_CONSULTA_ELETIVA.LABEL_DATA_ATENDIMENTO}
                </label>
              </div>
              <div className={"div-date-input"}>
                <Input
                  type="date"
                  style={{ width: 312 }}
                  name="date"
                  value={this.state.date}
                  className={this.state.isDateValid ? "" : "error"}
                  iconPosition="left"
                  // popupPosition="right center"
                  // closable={true}
                  onChange={this.dateChange}
                  disabled={this.state.disabled && beneficiario ? true : false}
                />
              </div>
              <ErrorMsgLabel
                boolean={!this.state.isDateValid}
                message={m.TELA_CONSULTA_ELETIVA.MENSAGEM_DATA_INVALIDA}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field
              inline={true}
              className={numeroCarteiraClassName}
              disabled={this.state.disabled && beneficiario ? true : false}
            >
              <div className={"div-separador-top"}>
                <label className={"form-autorizacao-label"}>
                  {m.TELA_CONSULTA_ELETIVA.LABEL_NUMERO_CARTEIRA}
                </label>
              </div>
              <Input
                style={{ width: 312 }}
                className={this.state.isNumeroCarteiraEmpty ? "error " : ""}
                name="numeroCarteira"
                icon="id card"
                ref={(input) => {
                  this.textInput = input;
                }}
                iconPosition="left"
                value={this.state.numeroCarteira}
                onChange={this.handleChange}
                disabled={this.state.disabled && beneficiario ? true : false}
              />
              <ErrorMsgLabel
                boolean={this.state.isNumeroCarteiraEmpty}
                message={m.TELA_CONSULTA_ELETIVA.MENSAGEM_CAMPO_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field
              inline={true}
              className={fieldClassName}
              disabled={this.state.success && beneficiario ? true : false}
            >
              <Checkbox
                name="recemNascido"
                label={m.TELA_CONSULTA_ELETIVA.LABEL_RECEM_NASCIDO}
                type="checkbox"
                style={{ marginTop: 30, fontFamily: "Work Sans" }}
                checked={this.state.recemNascido}
                onChange={this.handleCheckboxChange}
              />
            </Form.Field>
          </Form.Group>
        </Form>
        <CustomSnackbar
          setClick={(click) => (this.clickChild = click)}
          variant="error"
          duration={4000}
          content={m.TELA_CONSULTA_ELETIVA.MENSAGEM_ERRO_SERVICO_ELEGIBILIDADE}
        />
        <CustomSnackbar
          setClick={(click) => (this.dataMaior = click)}
          variant="warning"
          duration={2000}
          content={m.TELA_CONSULTA_ELETIVA.NOTIFICACAO_DATA_MENOR}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateBeneficiatioState,
      resetBeneficiarioState,
      getBeneficiario,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(FormElegibilidade);
